export const NAVIGATION_ITEM_STATE = {
  DEFAULT: 'default',
  ACTIVE: 'active',
};

export const getPropsConsideringNavigationItemState = (
  { whenActive = {}, ...item },
  navigationItemState
) => {
  return navigationItemState === NAVIGATION_ITEM_STATE.ACTIVE
    ? { ...item, ...whenActive }
    : { ...item };
};

export const isCurrentPath = (routePath, itemPath) =>
  routePath === itemPath || routePath.startsWith(`${itemPath}/`);
